import * as React from 'react';
import { UserService } from "@fnv-core/authentication";
import { MijnFNVMenu } from '../widgets/MijnFNVMenu';
import { PageProps } from './interfaces/PageInterfaces';
import { CreateFormViewModel, createFormWidget, MenuHelpers, PageHelpers, PageRenderHelpers } from './helpers';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { AnimationService, ANIMATION_DASHBOARD_LOADING_CONTEXT, FormService } from "../../services";
import { BackLink, MemberState, PageTitle } from './components';

export class ViewDataPage extends React.Component<PageProps> {
    
    componentDidMount() {    
        AnimationService.enableFormAnimations();
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    }

    componentDidUpdate() {
        this.handleAnimations();
    }

    handleAnimations() {
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
        AnimationService.triggerAnimations();
    }

    render() {
        const mijnFnvViewPagina = this.props.kenticoPage.MijnFnvViewPagina;
        const { 
            HasActionsAndHeadingForm, PageWidth, ShowSideBar, BackToPageLinkUrl, BackToPageLinkText,
            BackLinkIsExternal , BackLinkExternalUrl 
        } = mijnFnvViewPagina;

        MenuHelpers.showBreadCrumbs();

        if (mijnFnvViewPagina.MenuType === "eenvoudig") {
            MenuHelpers.hideMenu();
        } else {
            MenuHelpers.showMenu();
        }

        PageHelpers.setBreadcrumbsPageTitle(mijnFnvViewPagina.Titel);
        PageHelpers.highlightMainNavigationItem();

        const pageWidthCssClass = PageRenderHelpers.getCssClassForPageWidthViewPageType(
            PageWidth,
            ShowSideBar,
            HasActionsAndHeadingForm
        );

        let memberDetails: { memberName?: string, isMember?: boolean } = null;
        if (
            this.context &&
            this.context.pathParam &&
            this.context.pathParam !== UserService.getUserId()
        ) {
            memberDetails = FormService.getLidZoekenSubFunctionsForMember();
        }

        let DetailFormViewModel;
        if (HasActionsAndHeadingForm) {
            DetailFormViewModel = CreateFormViewModel(
              mijnFnvViewPagina.DetailFormDefinition,
              mijnFnvViewPagina.FormName, 
              mijnFnvViewPagina.FormType,
              "",
              mijnFnvViewPagina.Titel);
        }

        // If there is a sidebar, heading should be <h2> instead of <h1>
        const headingIsMain = mijnFnvViewPagina.ShowSideBar !== true;

        this.handleAnimations();
        
        return <React.Fragment>
            <div className="row mijn-fnv__view-page">
                {!HasActionsAndHeadingForm && <div className="col-12 col-md-1" />}
                {ShowSideBar ? <div className="mijn-fnv__sidemenu col-12 col-md-2">
                    {MijnFNVMenu(PageHelpers.getSideMenu(this.props.kenticoPage), this.context.pathname)}
                </div> : null}
                {HasActionsAndHeadingForm ? <div className="mijn-fnv__actionblock col-12 col-md-4">
                    <BackLink backToPageLinkText={BackToPageLinkText} 
                        backToPageLinkUrl={BackLinkIsExternal ? BackLinkExternalUrl : BackToPageLinkUrl} 
                        isExternalUrl={!!BackLinkIsExternal}
                    />
                    {createFormWidget(
                        DetailFormViewModel,
                        "widget mijn-fnv__widget mijn-fnv__view-action-form",
                        0,
                        'view'
                    )}
                </div> : null}
                <div className={"mijn-fnv__mainBlock col-12 " + pageWidthCssClass}>
                    <div className="mijn-fnv__mainBlock-inner">
                      <PageTitle
                        main={headingIsMain}
                        title={mijnFnvViewPagina.Titel}
                        subtitleRender={memberDetails ? () => <MemberState {...memberDetails} /> : null}
                        subtitleModifierClass='member-name'
                        intro={mijnFnvViewPagina.Subtitle}
                        >
                        </PageTitle>

                        {// Get all widgets to be shown in page
                        PageHelpers.getWidgets(this.props.kenticoPage).map((widgetDefinition, index) => {
                          const definition = {
                            ...widgetDefinition,
                            editMode: false,
                          };
                          // Get the proper widget based on type, set to edit mode
                          return PageRenderHelpers.renderWidget(
                              definition,
                              '',
                              index,
                              'view'
                          );
                        })}
                    </div>
                </div>
                {!HasActionsAndHeadingForm && <div className="col-12 col-md-1" />}
            </div>
        </React.Fragment>;
    }

    static contextType = MijnFNVPageContext;
    context!: React.ContextType<typeof MijnFNVPageContext>;
}